<template>
  <a-modal v-model="showModal" class="modalContainer text-center p-4 congratsModal" :footer="null" :closable="false">
    <img class="rounded-circle" src="../../../assets/icons/confetti-congrats.png" alt="congo" />
    <h4 class="gray700 mb-3 mt-2">Congratulations!</h4>
    <p class="gray500 mb-0">You successfully created your first post.</p>
    <button class="rounded w-100 mt-5 p1224 fw700 font14 font-white" @click="handleCancel" :style="{ background: getPrimaryColor(), border: 'none' }">Continue</button>
  </a-modal>
</template>

<script>
export default {
  data() {
    return { showModal: false }
  },
  props: {
    showInfoModal: Function,
  },
  methods: {
    show() {
      this.showModal = true
    },
    handleCancel() {
      this.showModal = false
      this.showInfoModal()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/activity/Congrats.vue